<template>
  <v-app>
    <Navbar />

    <v-content>
      <router-view></router-view>
    </v-content>

  </v-app>
</template>

<script>
import Navbar from '@/components/Navbar'

export default {
  name: 'App',
  components: {
    Navbar
  },
  data () {
    return {
      //
    }
  }
}
</script>
<style>
@import url('https://fonts.googleapis.com/css?family=M+PLUS+1p&display=swap');
body {
    font-family: 'M PLUS 1p';
    background-color: #f4f5f7;
}
</style>

